export default __webpack_public_path__ + "static/media/shoppingHistoryLightMode.ed5af270.svg";